<template>
        <div id='myclient'>
              <NavTop title='我的客户' :islink='true'/>
              <div class='content'>
                  <div class="title">我的下阶汇总(总数:{{sumtotal}})</div>
                  <div class="clientgroup">
                     <div class="col" v-for="item in suminfo" :key="item.name">
                        <div class="nums">{{item['nums']}}</div>
                        <div class="levelname">{{item['name']}}</div>
                      </div>
                  </div>
              </div>  
              <div class='content'>
                  <div class="title">我的一阶客户详情</div>
                  <div class="clientgroup">
                     <div class="col" @click="goSetLevel(0)">
                        <div class="nums">{{clients['level0']}}</div>
                        <div class="levelname">注册会员</div>
                      </div>
                       <div class="col" @click="goSetLevel(1)">
                            <div class="nums">{{clients['level1']}}</div>
                            <div class="levelname">普通会员</div>
                       </div>
                       <div class="col"  @click="goSetLevel(2)">
                        <div class="nums">{{clients['level2']}}</div>
                        <div class="levelname">VIP客户</div>
                        </div>
                        <div class="col"  @click="goSetLevel(3)">
                           <div class="nums">{{clients['level3']}}</div>
                           <div class="levelname">门店代理</div>
                      </div>
                      <div class="col"  @click="goSetLevel(4)">
                        <div class="nums">{{clients['level4']}}</div>
                        <div class="levelname">区域代理</div>
                       </div>
                       <div class="col"  @click="goSetLevel(5)">
                        <div class="nums">{{clients['level5']}}</div>
                        <div class="levelname">市级代理</div>
                       </div>
                       <div class="col"  @click="goSetLevel(6)">
                        <div class="nums">{{clients['level6']}}</div>
                        <div class="levelname">省级代理</div>
                      </div>

                  </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
         clients:{},
         suminfo:[],
         sumtotal:0
      }
  },  
  name: 'myclient',
  created(){
     this.getMyClient()
  },
  methods:{
      getMyClient(){
        this.$post("/user/getMyClientsNew",{}).then((data)=>{
           if(data.result.success){
               this.clients=data.result.info.clients
               this.suminfo=data.result.info.suminfo
               this.sumtotal=data.result.info.sumtotal
           }
        })
     },
     goSetLevel(level){
        this.$go('/alterlevel/'+level)
     }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#myclient{background-color:#F6F6F6;min-height: 100vh;}
.content{padding: 0.25rem;border-radius: 0.2rem;display: flex;flex-flow: column nowrap;background-color: #fff;margin: 0.2rem;}
.title{font-size:0.36rem;color:#333;text-align: left;padding: 0.15rem;font-weight: 600;}
.clientgroup{display: flex;flex-flow: row wrap;}
.col{display: flex;flex-flow: column nowrap;padding: 0.15rem;flex:0 0 33%;}
.nums{font-size:0.4rem;}
.levelname{font-size: 0.35rem;}
</style>


